import PropTypes from 'prop-types';
import Dropdown from '@/common-utils/components/renders/dropdown/Dropdown';
import ICONS from '@/common-utils/enums/icons';
import ModalUpdateLabel from '../modals/ModalUpdateLabel';
import Permissions from '@/app/permissions/Permissions';
import notifRulesFields from '../../fields/notifRulesFields';
import { useState } from 'react';
import useSessionStore from '@/app/store/session';
import ModalRemoveNotifRule from '../modals/ModalRemoveNotifRule';
import { nsNotifRules } from '@/app/i18n/namespaces';
import hasRequiredPermissions from '@/common-utils/functions/hasRequiredPermissions';
/**
 * @returns {JSX.element}
 */
function DropdownNotifRulesActionsRow({ pushPaymentNotifRule, setLaunchRefetch }) {
    //Constants
    const pushPaymentNotifRuleId = pushPaymentNotifRule ? pushPaymentNotifRule[notifRulesFields.UUID.key] : null;
    const pushPaymentNotifRuleLabel = pushPaymentNotifRule ? pushPaymentNotifRule[notifRulesFields.LABEL.key] : null;
    // Store
    const permissions = useSessionStore(s => s.session.permissions);
    //State
    const [showModalUpdateLabel, setShowModalUpdateLabel] = useState(false);
    const [showModalNotifRule, setShowModalNotifRule] = useState(false);
    //Functions
    const handleShowModalUpdateLabel = () => {
        setShowModalUpdateLabel(true);
    };
    const handleShowModalNotifRule = () => {
        setShowModalNotifRule(true);
    };
    return (
        <>
            <Dropdown
                id={'accounts-page-actions'}
                triggerValues={{ variant: 'ghostNoBorder', icon: ICONS.MORE }}
                dataCy='notif-rules-actions-dropdown-row'
                actions={[
                    {
                        icon: ICONS.EDIT,
                        entity: 'actions.row.update_label',
                        namespace: nsNotifRules,
                        onClick: handleShowModalUpdateLabel,
                        visible: true,
                        disabled: !hasRequiredPermissions({
                            permissions: permissions,
                            requiredPermissions: [Permissions.PUSH_PAYMENT_UPDATE.name]
                        }),
                        tooltipForbidden: 'title.permissions.access_denied'
                    },
                    {
                        icon: ICONS.CLOSE,
                        entity: 'actions.row.delete',
                        namespace: nsNotifRules,
                        onClick: handleShowModalNotifRule,
                        visible: true,
                        disabled: !hasRequiredPermissions({
                            permissions: permissions,
                            requiredPermissions: [Permissions.PUSH_PAYMENT_DELETE.name]
                        }),
                        tooltipForbidden: 'title.permissions.access_denied'
                    }
                ]}
            />
            {
                showModalUpdateLabel &&
                <ModalUpdateLabel
                    isOpen={showModalUpdateLabel}
                    setIsOpen={setShowModalUpdateLabel}
                    pushPaymentNotifRuleId={pushPaymentNotifRuleId}
                    pushPaymentNotifRuleLabel={pushPaymentNotifRuleLabel}
                    setLaunchRefetch={setLaunchRefetch}
                />
            }
            {
                showModalNotifRule &&
                <ModalRemoveNotifRule
                    isOpen={showModalNotifRule}
                    setIsOpen={setShowModalNotifRule}
                    pushPaymentNotifRuleId={pushPaymentNotifRuleId}
                    setLaunchRefetch={setLaunchRefetch}
                />
            }
        </>
    );
}
DropdownNotifRulesActionsRow.propTypes = {
    pushPaymentNotifRule: PropTypes.object.isRequired,
    setLaunchRefetch: PropTypes.func.isRequired
};
export default DropdownNotifRulesActionsRow;